import { useMutation } from '@tanstack/react-query'
import { gameBoxRoomService } from '../../../../services/games/games-boxes-rooms'

export const useGetGameBoxRoomEarning = () => {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: gameBoxRoomService.get,
  })

  return {
    getGameBoxRoomEarning: mutateAsync,
    isLoading: isPending,
  }
}
